import colors from 'fe-design-base/styles/colors';
import designTokens from 'theme/design-tokens';

const aiConfig = designTokens.ai;

export type IconAIGradientDefsProps = {
  gradientId: string;
  isAnimating?: boolean;
  duration?: string;
};

export const IconAIGradientDefs = ({
  gradientId,
  isAnimating = false,
  duration = aiConfig.animatingSpeed,
}: IconAIGradientDefsProps) => {
  const values = `${[
    colors.purple700,
    colors.purple500,
    colors.accent500,
    colors.purple500,
    colors.purple700,
  ].join('; ')};`;

  return (
    <linearGradient id={gradientId} gradientUnits="userSpaceOnUse">
      <stop offset="0%" stopColor={colors.purple700}>
        {isAnimating && (
          <animate
            attributeName="stop-color"
            dur={duration}
            values={values}
            repeatCount="indefinite"
          />
        )}
      </stop>
      <stop offset="30%" stopColor={colors.purple500}>
        {isAnimating && (
          <animate
            attributeName="stop-color"
            dur={duration}
            values={values}
            repeatCount="indefinite"
          />
        )}
      </stop>
      <stop offset="100%" stopColor={colors.accent500}>
        {isAnimating && (
          <animate
            attributeName="stop-color"
            dur={duration}
            values={values}
            repeatCount="indefinite"
          />
        )}
      </stop>
    </linearGradient>
  );
};

export function aiFill({
  gradientId,
  isAI = false,
  isAnimating = false,
  fallbackColor = 'currentColor',
}: {
  gradientId: string;
  isAI?: boolean;
  isAnimating?: boolean;
  fallbackColor?: string;
}): string {
  return isAI || isAnimating ? `url(#${gradientId})` : fallbackColor;
}
